package ru.villawonka.app.data.service

import ru.villawonka.app.domain.service.UserSettingsService

class UserSettingsServiceImpl: UserSettingsService {

    private val listeners = mutableSetOf<UserSettingsService.Listener>()

    override fun onSettingsChangedNotifyAll() {
        listeners.forEach { it.onSettingsChanged() }
    }

    override fun addDelegate(listener: UserSettingsService.Listener) {
        listeners.add(listener)
    }

    override fun removeDelegate(listener: UserSettingsService.Listener) {
        listeners.remove(listener)
    }
}